import React, { useState } from 'react';
import intl from 'react-intl-universal';
import { useLocation } from 'react-router-dom';
import { Dropdown, Menu, Row, Tooltip } from 'antd';
import { goMyAccount, navToWithBlank, signOutFromAvatar } from '../../utils/utils';
import { TO_ADMIN_CONSOLE } from '@/components/viewer/ui/constants/user.more.constants';
import store from '@/store';
import { genAvatarBgColor, trim } from '../../utils/tools';
import UserAvatar from './UserAvatar';
import { getLoggedInAvatarMenu } from './getLoggedInAvatarMenu';
import { trimStr } from '@/utils/utils';

export default function LoggedInAvatar(props) {
    const {
        userInfo,
        userName: avatar_name,
    } = store.userStore;
    if (!userInfo) return null;

    let avatar = null;
    if (userInfo.isDefaultAvatar == 0) {
        avatar = userInfo.avatar;
    }
    const [background] = useState(genAvatarBgColor(userInfo.cUserID));
    const location = useLocation();
    const normalAvatarDropdown = getLoggedInAvatarMenu.bind(null, {
        pathname: location.pathname,
        renderLangMenu: props.renderLangMenu,
        forLangKey: props.forLangKey,
    });
    const fullName = userInfo?.full_name && trimStr(userInfo.full_name)
    const userEmail = userInfo?.full_name && trimStr(userInfo.userEmail)
    const userMobile = userInfo?.full_name && trimStr(userInfo.userMobile)

    return (
        <Tooltip overlayClassName="header-user-tooltip" placement="bottomRight" title={fullName || userEmail || userMobile}>
            {/* @ts-ignore */}
            <Dropdown
                overlay={normalAvatarDropdown}
                placement="bottomRight"
                trigger={['click']}
                onVisibleChange={open=>{
                    if (!open) return;
                    store.userStore.getUserSubInfoRightNow();
                }}
            >
                <UserAvatar avatar={avatar} background={background} name={avatar_name} label={fullName || userEmail} />
            </Dropdown>
        </Tooltip>
    );
}

interface AvatarProps {
    adminUrl?: string,
    hideCheckoutAccount?: boolean,
    accountTitle?: string;
    account: string;
    pathname: string;
}
/**
 * @deprecated `refactor legacy`
 * This refactoring was several months ago, and too much has changed now.
 */
function AvatarDropdown({
    adminUrl,
    hideCheckoutAccount,
    accountTitle,
    account,
    pathname
}: AvatarProps) {
    return (
        // @ts-ignore
        <Menu className="user-dropdown-menu-wrapper">
            <Menu.Item style={{ cursor: 'default' }}>
                <div>
                    <Row>
                        <span>{accountTitle || intl.get("account.Mail")}</span>
                    </Row>
                    <Row className={'lh-14'}>
                        <span className={'c-999 fs-10 lh-10'}>{trim(account)}</span>
                    </Row>
                </div>
            </Menu.Item>
            {
                adminUrl ?
                    <Menu.Item>
                        <a onClick={navToWithBlank.bind(null, adminUrl, TO_ADMIN_CONSOLE)}>
                            {intl.get("user.toAdminConsole")}
                        </a>
                    </Menu.Item> :
                    null
            }
            {
                !hideCheckoutAccount ?
                    <Menu.Item onClick={goMyAccount}>
                        <span >{intl.get('account.title')}</span>
                    </Menu.Item> :
                    null
            }
            <Menu.Item onClick={signOutFromAvatar.bind(null, pathname)}>{intl.get("user.signOut")}</Menu.Item>
        </Menu>
    )
}
